module.exports = __webpack_public_path__ + "static/media/skintype_u.718a9762.svg";